import React, { Component } from 'react';
import { render } from 'react-dom';

import Highcharts from 'highcharts';
import highchartsMore from "highcharts/highcharts-more";
import HighchartsReact from 'highcharts-react-official';
import RadialBarChart from './RadialBarChart';
import colors from 'react-multi-date-picker/plugins/colors';

highchartsMore(Highcharts);



const RadialBarHighChart = (props) => {

  const options = {
      colors: [  '#CD7F32','orange','green','black'],
        chart: {
            type: 'column',
            inverted: true,
            polar: true
        },
        // title: {
        //     text: 'Quzz X Progress'
        // },
        tooltip: {
            outside: true
        },
        pane: {
            size: '90%',
            innerSize: '20%',
            endAngle: 270
        },
        xAxis: {
            tickInterval: 1,
            labels: {
                // align: 'right',
                // useHTML: true,
                allowOverlap: false,
                // step: 1,
                y:3,
                style: {
                    fontSize: '13px'
                    
                }
            },
            // lineWidth: 0,
            categories: props.labels
        },
        yAxis: {
            crosshair: {
                enabled: true,
                color: 'green'
            },
            lineWidth: 0,
            // tickInterval: 25,
            // reversedStacks: false,
            // endOnTick: true,
            showLastLabel: true
        },
        plotOptions: {


            // dataLabels: {
            //     enabled: true,
            //     //format: '% {point.percentage:.0f}<br/>{point.custom}',
            //     formatter: function () {
            //       return "% " + Math.round(this.point.percentage) + "<br/>" + (this.point.custom ? this.point.custom : this.point.name)
            //     },
            //     style: {
            //       color: (Highcharts.theme && Highcharts.theme.contrastTextColor) || 'black'
            //     }
            //   },
            
            
            // column: {
            //     colors: ['orange','green','black'],
                
            //     borderWidth: 0,
            //     pointPadding: 0,
            //     groupPadding: .10
            // },

            series: {
                pointPadding: 0,
                groupPadding: 0,
                // colorByPoint: true,
                color: '#5F8D4E',
                dataLabels: {
                    enabled: true,
                    inside: true,
                    allowOverlap: true,
                    colorByPoint: true,
                }
            }
        },
        series: [{
            data:props.db,
            zones: [{
                value: 50,
                color: '#f7a35c'
            }, {
                value: 100,
                color: '#7cb5ec'
            }, {
                value: 150,
                color: '#90ed7d'
            },
            {
                value: 200,
                color: '#1cb5ec'
            }, 
            {
                value: 250,
                color: '#0cb5ec'
            }, 
        
        ]
        }]
    }



return(




<div>
  <HighchartsReact
    highcharts={Highcharts}
    options={options}
  />
</div>
)
}


export default RadialBarHighChart


